import { Endpoints } from "../../../constants/endpoints";
import { TUserRaw } from "./types";
import client from "../../client";

export const getUserById = (userId: string | number) => async () => {
  const { data } = await client.get<TUserRaw>(Endpoints.getUserById(userId));
  return data.user;
};
